module.exports = __webpack_public_path__ + "static/img/591.b405162.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/rjzz/591.jpg
// module id = WlGF
// module chunks = 0